import React from 'react';
import { Bell } from 'lucide-react';
import { KamishibaiSymbolBadge } from './KamishibaiSymbol';
import type { KamishibaiMatrixViewMode } from '../../hooks/useKamishibaiMatrixModel';

interface KamishibaiLegendBarProps {
  viewMode: KamishibaiMatrixViewMode;
}

/** Legenda Kamishibai — rodapé sticky discreto. */
export const KamishibaiLegendBar = React.memo<KamishibaiLegendBarProps>(function KamishibaiLegendBar({
  viewMode,
}) {
  return (
    <footer className="sticky bottom-0 z-20 flex shrink-0 flex-wrap items-center justify-center gap-x-4 gap-y-0.5 border-t border-slate-200 bg-white/95 px-3 py-1.5 text-[9px] text-slate-500 backdrop-blur-sm dark:border-slate-800 dark:bg-slate-950/95 dark:text-slate-400">
      <LegendItem icon={<KamishibaiSymbolBadge symbol="O" size="sm" />} label="Conforme (O)" />
      <LegendItem icon={<KamishibaiSymbolBadge symbol="triangle" size="sm" />} label="Desvio (Δ)" />
      <LegendItem icon={<KamishibaiSymbolBadge symbol="X" size="sm" />} label="Não realizado (X)" />
      {viewMode === 'hourly' && (
        <LegendItem icon={<Bell size={9} className="text-amber-500" />} label="Alerta antecipado" />
      )}
    </footer>
  );
});

const LegendItem: React.FC<{ icon: React.ReactNode; label: string }> = ({ icon, label }) => (
  <span className="inline-flex items-center gap-1 whitespace-nowrap">
    {icon}
    {label}
  </span>
);

export default KamishibaiLegendBar;
